module.exports = __webpack_public_path__ + "img/Notioly1.b60d039b.png";